import classes from "./ThankYouPage.module.scss";
import { Heading } from "@/components/ui/Heading";
import type { ThankYouPageHeaderProps } from "./ThankYouPageProps";
import { useDonationFormStore } from "@/stores";
import { useTranslation } from "@/hooks/useTranslation";
import { useAppConfig } from "@/hooks/useAppConfig";

export function ThankYouPageHeader(props: ThankYouPageHeaderProps) {
  const { config, translationsParams } = props;

  const { personalDetails } = useDonationFormStore();

  const t = useTranslation("thank_you_page");

  const title = t(config["thank-you-page-title"].i18n, translationsParams);
  const { logo, home_url } = useAppConfig();

  return (
    <div className={classes.marginBottom}>
      <div className={classes.header}>
        <a href={home_url} className={classes.logoLink}>
          <img
            src={logo.src}
            alt={logo.alt}
            width={logo.width}
            height={logo.height}
            className={classes.logo}
          />
        </a>
      </div>

      {personalDetails.firstName && (
        <div className={classes.name}>
          {t(config["thank-you-page-message"].i18n, translationsParams)}
        </div>
      )}

      {title && (
        <Heading size="2xl" gutterBottom>
          {title}
        </Heading>
      )}

      <div className={classes.formatter}>
        {t(config["thank-you-page-body"].i18n, translationsParams)}
      </div>
    </div>
  );
}
